import { TocActionSignal } from "contexts/signalr/interface";
import { FROM_SIGNALR, ITocActionFromSignalR } from "./tocContextReducer";

/**
 * Convert a ToC action signal from SignalR into the internal
 * `ITocActionFromSignalR` structure for reducer processing.
 *
 * @param messageId - The SignalR message identifier for this event.
 * @param actionSignal - The ToC action payload received from SignalR.
 * @returns The transformed `ITocActionFromSignalR` ready for reducer dispatch.
 */
export const processActionFromSignal = (
  messageId: string,
  actionSignal: TocActionSignal,
): ITocActionFromSignalR => {
  const updatedIds: string[] = [
    actionSignal.deletedItemId,
    ...actionSignal.items.map((x) => x.id),
  ].filter((x) => x !== undefined) as string[];
  return {
    operation: FROM_SIGNALR,
    items: actionSignal.items,
    deletedItemId: actionSignal.deletedItemId,
    receivedMessage: { messageId, updateTS: new Date(), updatedIds },
  };
};
